import {
  Button,
  Card,
  Flex,
  Heading,
  Text,
  TextField,
} from "@radix-ui/themes";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { useFetch } from "../../hooks/useFetch";

import { useAppStore } from "../../stores/RootStore";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

type EnterInputs = {
  password: string;
};

export default function ResetPasswordView() {
  const store = useAppStore();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<EnterInputs>();

  let hash = useParams();
  const [{ response }, doSetNewPassword] = useFetch(`/users/sessions`, true);
  const onSubmit: SubmitHandler<EnterInputs> = (data) => {
    const req = { ...data, ...hash };
    console.log(req);
    doSetNewPassword({ method: "POST", data: req });
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (response != null && response.data.status == "ok") {
      console.log("redirect");
      navigate("/");
    }
  }, [response]);

  return (
    <Flex height="100%" justify="center" align="center">
      <Card style={{ maxWidth: 420, minWidth: 420 }}>
        <Heading mb="4" mt="2" mx="2" weight="bold">
          Создание нового пароля
        </Heading>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-col gap-4 px-2"
        >
          <Controller
            control={control}
            name="password"
            rules={{ required: true }}
            render={({ field: { onChange, onBlur, value } }) => (
              <label>
                <Text as="div" size="1" mb="1" weight="medium">
                  Введите пароль
                </Text>
                <TextField.Input onChange={onChange} />
                {errors.password && <div role="alert" className="text-sm text-red-600">Введите пароль</div>}
              </label>
            )}
          />
          <Button my="4">Создать новый пароль</Button>
        </form>
      </Card>
    </Flex>
  );
}
